export const leadCardData = [
  {
    id: 1,
    title: 'Fresh Leads',
    key: 'fresh-lead',
    icon: '/assets/media/leads/fresh_lead.svg',
    bgcolor: 'linear-gradient(120.51deg, #6D9300 31.46%, #A8CB43 92.66%)',
  },
  {
    id: 2,
    title: 'In Progress',
    key: 'In Progress',
    icon: '/assets/media/leads/in_progress.svg',
    bgcolor: '#FFFFFF',
  },
  {
    id: 3,
    title: 'Reviewed',
    key: 'Reviewed',
    icon: '/assets/media/leads/reviewed.svg',
    bgcolor: '#FFFFFF',
  },
  {
    id: 4,
    title: 'Converted',
    key: 'Converted',
    icon: '/assets/media/leads/converted.svg',
    bgcolor: '#FFFFFF',
  },
  {
    id: 5,
    title: 'Rejected',
    key: 'Rejected',
    icon: '/assets/media/leads/rejected.svg',
    bgcolor: '#FFFFFF',
  },
]
